import { render, staticRenderFns } from "./TaxRateAndPremiums.vue?vue&type=template&id=dafaa5a6&scoped=true&"
import script from "./TaxRateAndPremiums.vue?vue&type=script&lang=js&"
export * from "./TaxRateAndPremiums.vue?vue&type=script&lang=js&"
import style0 from "./TaxRateAndPremiums.vue?vue&type=style&index=0&id=dafaa5a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafaa5a6",
  null
  
)

export default component.exports